import { DateTime } from 'luxon';

export const datesInProgramSpan = (startsOn: string, endsOn: string): string[] => {
  let cursor = DateTime.fromISO(startsOn, { zone: 'utc' }).startOf('day');
  const end = DateTime.fromISO(endsOn, { zone: 'utc' }).startOf('day');
  if (!cursor.isValid || !end.isValid || end < cursor) return [];
  const dates: string[] = [];
  while (cursor <= end) {
    const iso = cursor.toISODate();
    if (iso) dates.push(iso);
    cursor = cursor.plus({ days: 1 });
  }
  return dates;
};

export interface ProgramDayDetail {
  id: string;
  programId: string;
  guestSpeaker: string | null;
  /** Linked minister from People → Ministers; null for visiting speakers. */
  speakerMinisterId: string | null;
  /** Church member speaking on this day. */
  speakerMemberId: string | null;
  speakerMemberName: string | null;
  theme: string | null;
  scriptureRefs: string[];
  /** First reading; prefer `scriptureRefs`. */
  scriptureRef: string | null;
  description: string | null;
  imageKey: string | null;
  imageUrl: string | null;
  startTime: string | null;
  endTime: string | null;
  venueId: string | null;
  venueName: string | null;
  dates: string[];
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}
